import React from 'react';
import classnames from 'classnames';
import RemoveDashboardPopup from '../RemoveDashboardPopup';
import styled from 'styled-components';

const StyledLink = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;

  &:disabled {
    color: rgb(104 104 104 / 40%);
    font-style: italic;
    font-weight: 400;
  }

  width: 100% !important;
`;

// eslint-disable-next-line react/display-name
const DeleteDashboard = React.memo(({ className = '', id, toggleVisible }) => (
  <>
    <StyledLink className={classnames(className)} onClick={toggleVisible}>
      <span>Delete</span>
    </StyledLink>
    <RemoveDashboardPopup id={id} />
  </>
));

export default DeleteDashboard;
